"use client";

import { createContext } from "react";

const Context = createContext(undefined);

export default Context;
